import styled from "@emotion/styled";
import { Text } from "@atlas-int/ui";
import GlossaryContent from "./Content";
import { DetailsPageContainer } from "../../components/layout/StaticPageLayout";
import ResearchFooter from "../../components/footer/ResearchFooter";
import { useLocation } from "react-router";
import { useEffect } from "react";

const PageTitle = styled(Text)`
  margin-top: 0;
`;

const Glossary = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <DetailsPageContainer>
        <PageTitle variant="heading-1">Glossary</PageTitle>
        <GlossaryContent />
      </DetailsPageContainer>
      <ResearchFooter />
    </>
  );
};

export default Glossary;
